<template>
    <!-- 86bcfa7n0: the one-time passcode inside the report's steps. -->
    <report-layout
        :report="report"
        :identity-verified="identity_verified"
        current-step="verify_identity"
    >
        <otp-form
            submit-route="reports.verify-identity.otp.submit"
            :submit-params="report.id"
            :cancel-href="route('reports.dashboard', report.id)"
        />
    </report-layout>
</template>

<script>
import ReportLayout from './ReportLayout.vue'
import OtpForm from '@/Components/ExperianVerification/OtpForm.vue'

export default {
    components: {
        ReportLayout,
        OtpForm,
    },
    props: {
        report: Object,
        identity_verified: { type: Boolean, default: false },
    },
}
</script>
